export function detectFocusDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: detectFocusDirectiveCtrl,
	};
}
export class detectFocusDirectiveCtrl {
	constructor($scope, $element, $attrs) {
		'ngInject';
		this.$scope = $scope;
		this.$element = $element;
		this.$attrs = $attrs;
		this.state = 'blurred';
		this.listen();
	}

	notify($type) {
		this.$scope.$eval(this.$attrs.shDetectFocus, { $type });
		this.$scope.$digest();
	}

	listen() {
		this.clickHandler = this.clickHandler.bind(this);
		document.addEventListener('click', this.clickHandler, false);
	}

	$onDestroy() {
		document.removeEventListener('click', this.clickHandler);
	}

	clickHandler(evt) {
		if (isOrIsElementChildOf(evt.target, this.$element[0])) {
			if (this.state != 'focused') {
				this.state = 'focused';
				this.notify('focus');
			}
		} else if (this.state == 'focused') {
			this.state = 'blurred';
			this.notify('blur');
		}
	}
}

/*
 * Return true if the first given element is a child of the second.
 * Used to detect drag hover state
 * @param {DOMElement} child  The potential child element
 * @param {DOMElement} parent  The parent element
 * @returns {Boolean}
 */
function isOrIsElementChildOf(child, parent) {
	while (child) {
		if (child === parent) {
			return true;
		}
		child = child.parentNode;
	}
	return false;
}
